export const ACCEPTED_VIDEO_UPLOAD_TYPES = {
  'video/mp4': ['.mp4'],
  'video/quicktime': ['.mov'],
}
